import { Command } from 'commands/Commands';

export class ChangeDisclosureStatement extends Command {
  type: string = 'Member.ChangeDisclosureStatement';
  priority = 100;
}
